import { RootState } from "@redux/app/store"
import { FishFarmOwner } from "@redux/features/fishFarmOwners/fishFarmOwnersSlice"
import { createSlice, PayloadAction } from "@reduxjs/toolkit"

type LiceThreshold = {
	threshold: number
	showSitesBelowThreshold: boolean
	showSitesAboveThreshold: boolean
}

export type ConsumptionMapFilters = {
	showProductionSites: boolean
	liceThreshold: LiceThreshold
	reportingStatus: string
	selectedFishFarmOwner: FishFarmOwner
}

export const defaultState: ConsumptionMapFilters = {
	showProductionSites: false,
	liceThreshold: {
		threshold: 0.45,
		showSitesBelowThreshold: false,
		showSitesAboveThreshold: false,
	},
	reportingStatus: "0",
	selectedFishFarmOwner: { orgNo: null, name: "" },
}

const storedState = localStorage.getItem("consumptionMapFilters")
export const initialState: ConsumptionMapFilters =
	storedState !== null ? JSON.parse(storedState) : defaultState

const consumptionMapFiltersSlice = createSlice({
	name: "consumptionMapFilters",
	initialState,
	reducers: {
		updateConsumptionMapFilters(state, action: PayloadAction<ConsumptionMapFilters>) {
			localStorage.setItem("consumptionMapFilters", JSON.stringify(action.payload))
			return { ...state, ...action.payload }
		},
		updateConsumptionSelectedFishFarmOwner(state, action: PayloadAction<FishFarmOwner>) {
			return { ...state, selectedFishFarmOwner: { ...action.payload } }
		},
		resetConsumptionMapFilters(state) {
			localStorage.setItem("consumptionMapFilters", JSON.stringify(defaultState))
			return { ...state, ...defaultState }
		},
	},
})

export const {
	updateConsumptionMapFilters,
	resetConsumptionMapFilters,
	updateConsumptionSelectedFishFarmOwner,
} = consumptionMapFiltersSlice.actions

export const getConsumptionMapFilters = (state: RootState) => state.consumptionMapFilters
export const getConsumptionSelectedFishFarmOwner = (state: RootState) =>
	state.consumptionMapFilters.selectedFishFarmOwner
export default consumptionMapFiltersSlice.reducer
